import StorageSpace from './StorageSpace';

export default StorageSpace;
